import React, { Component } from 'react';
import { TextField, Checkbox, FormControlLabel, Grid, Icon } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import { withStyles } from '@material-ui/core/styles';
import * as validatorActions from '../../components/validator/store/actions'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import * as moment from 'moment';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    }
});

class NotificationForm extends Component {

    handleChange = field_name => event => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        this.props.updateNotificationForm(update_data);
    }

    render() {
        const { classes, currentNotification, view_type } = this.props

        // Below function modifies component properties to get the desired appearance
        //      in the 'detail' view. Previously, we just set the TextField to 'disabled'
        //      which had the side effect of setting the text to a transparent gray.

        const InputProps = (view_type) => {
            switch (view_type) {
                case ('detail'): {
                    return {
                        readOnly: true,
                        disableUnderline: true,
                        className: this.props.classes.readOnlyMargin
                    }
                }
                default: {
                    return {}
                };
            }
        }

        // Constant below is simply a helper to go ahead and assign props that do
        //      not differ between the text fields without needing to repeat them.

        const sharedTextFieldProps = {
            InputProps: InputProps(view_type),
            variant: view_type === 'detail' ? "standard" : "outlined",
            margin: 'normal',
            className: classes.textField
        }

        const read = {
            InputProps: InputProps('detail'),
            variant: "standard",
            margin: "normal",
            className: classes.textField
        }

        const helperText = (currentNotification) => {
            const role = this.props.auth.user.role
            // console.log(role)
            // console.log(currentNotification)
            const student_event = (currentNotification.NotificationType === 'retake_event' || currentNotification.NotificationType === 'retake_approval' || currentNotification.NotificationType === 'late_event' || currentNotification.NotificationType === 'instructor_note')
            if (student_event && role !== 'student') {
                return (
                    <div><Icon style={{ display: 'inline-block', marginBottom: '-6px' }}>priority_high</Icon>You must be logged in as your student account to access this event</div>
                )
            }
            return null
        }

        const createDate = (prop) => {
            if (prop) {
                return (
                    <Grid item xs={12}>
                        <TextField
                            id="CreationDate"
                            disabled
                            label="Creation Date"
                            value={moment(currentNotification.CreationDate).format('YYYY-MM-DD')}
                            // error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                            {...sharedTextFieldProps}
                            className={(currentNotification.CreationDate === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                        />
                    </Grid>
                )
            }
        }

        return (
            <Grid container spacing={24}>
                <Grid item xs={12}>
                    <form style={styles.insidePaper} autoComplete="off">
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="NotificationHeader"
                                label="Notification Header"
                                value={currentNotification.NotificationHeader}
                                onChange={this.handleChange('NotificationHeader')}
                                // helperText={validator.filter(v => v.field_name === 'QualificationName')[0].error_msg}
                                {...sharedTextFieldProps}
                                // className={(currentNotification.NotificationHeader === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="NotificationContent"
                                label="Notification Content"
                                value={currentNotification.NotificationContent}
                                onChange={this.handleChange('NotificationContent')}
                                // error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                                {...sharedTextFieldProps}
                                multiline
                                rows={"4"}
                                // className={(currentNotification.NotificationContent === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                            />
                        </Grid>
                        {createDate(currentNotification.notification_id != 0)}
                        {helperText(currentNotification)}
                    </form>
                </Grid>
            </Grid >
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateNotificationForm: Actions.updateNotificationForm
    }, dispatch);
}

function mapStateToProps({ qualificationApp, auth, validator, companyApp }) {
    return {
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationForm)));



// WEBPACK FOOTER //
// src/main/content/notification/NotificationForm.js